import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { eStatementPreferencesValidation } from './EStatementPreferences.validation';
import {
  EStatementPreferencesDTO,
  useEStatementPreferencesQuery,
} from '../../api/useEStatementPreferencesQuery';
import { toast } from '../../../CommonComponents/OPL/Toast/Toast';
import { useEStatementPreferencesMutation } from '../../api/useEStatementPreferencesMutation';

export const useEStatementPreferences = ({ onClose }) => {
  const formBag = useForm<EStatementPreferencesDTO>({
    resolver: yupResolver(eStatementPreferencesValidation),
  });

  const queryInfo = useEStatementPreferencesQuery();

  const { data } = queryInfo;

  const eStatementPreferencesMutation = useEStatementPreferencesMutation();

  const onSubmit = async (values: EStatementPreferencesDTO) => {
    if (!data) {
      return;
    }

    try {
      const { mutateAsync: updateEStatementPreferences } = eStatementPreferencesMutation;

      await updateEStatementPreferences({
        isEmailStatementEnabled: values.isEmailStatementEnabled,
        email: values.email,
        addressLine1: values.addressLine1,
        addressLine2: values.addressLine2,
        city: values.city,
        state: values.state,
        zipCode: values.zipCode,
      });

      onClose();

      if (data.isEmailStatementEnabled && !values.isEmailStatementEnabled) {
        toast.warning("You'll no longer receive eStatements.");
      } else if (!data.isEmailStatementEnabled && values.isEmailStatementEnabled) {
        toast.success("You'll receive eStatements from now on.");
      } else {
        toast.success('Your settings were successfully saved.');
      }
    } catch (err) {
      onClose();

      if (err instanceof Error) {
        toast.error(err.message);
      }

      console.error(err);
    }
  };

  return {
    data: {
      queryInfo,
      formBag,
    },

    actions: {
      onSubmit,
      mutation: eStatementPreferencesMutation,
    },
  };
};
